import React from 'react';
import Login from './Pages/Login';
// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import Dashboard from './Pages/Dashboard.jsx';

const App = () => {
  return (
    <>
      <Login />
    </>
)};

export default App;
